var directivesModule =  angular.module('directives',[]);
export default directivesModule.name;